export default "__VITE_ASSET__FbojG0Vv__"